<template>
  <div class="homepageIndia">
    <!-- <training-header></training-header> -->
    <div class="mdgridviewpage-bg">
      <div class="container-fluid">

        <div class="row pt-2" style="margin:0 !important;">
          <div class="col-2">
            <img src="../assets/img/fplmis/fpss.png" class="d-block m-auto img-fluid">
          </div>
          <div class="col-8">
            <h4 class="align-items-center d-flex h-100 justify-content-center mx-0 text-center text-white loginpageHeading" style="">Family Planning Dashboard</h4>
          </div>
          <div class="col-2">
            <img src="../assets/img/fplmis/nhm.png" class="d-block m-auto img-fluid" style="">
          </div>
        </div>
      </div>
      <div class="container-fluid m-t-10px vertCenter">
        <div class="row dashboardchart-container globalconfigcontainer">
          <div class="col-lg-12 d-flex justify-content-center align-item-center" style="margin:10% auto 4%;">
            <div class="card m-b-20px m-t-20px">
              <!-- <div
                class="card-header text-decoration-none p-l-16px p-12px"
                id="headingOne"
              >
                 Activate an Account
              </div> -->
              <div class="collapse show" aria-labelledby="headingOne">
                <ValidationObserver v-slot="{ handleSubmit }">

                  <div class="card-body c-body" style="padding: 10px 20px 16px !important;">
                    <form @submit.prevent="handleSubmit(onSubmit)" class="d-flex">
                      <div class="row col-lg-12" style="margin: 0 auto;">
                        <div class="w-100 logoImage">
                            <div class="logoImageDiv">
                            <img src="../assets/img/fplmis/dfc.png" class="d-block m-auto" style="">
                            </div>
                          </div>
                        <h4 class="inner-heading text-center pt-2 pb-1 w-100 mt-3" style="font-weight: 400; mt-5">
                          Account Activation
                        </h4>
                        <div class="mainform-holder w-100">
                          <div class="col-lg-12">

                            <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                              <!-- <label
                                for="inputContactEmail"
                                class="col-sm-4 col-form-label"
                                >Email</label
                              > -->
                              <div class="col-sm-12">
                                <ValidationProvider name="E-mail" rules="required|email" v-slot="{ errors }">
                                  <input
                                    v-model="email"
                                    type="email"
                                    class="form-control bg-grey"
                                    id="inputContactEmail"
                                    placeholder="Email"
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                              <!-- <label
                                for="inputToken"
                                class="col-sm-4 col-form-label"
                                >Token</label
                              > -->
                              <div class="col-sm-12">
                                <ValidationProvider name="Token" rules="required" v-slot="{ errors }">
                                  <input
                                    v-model="token"
                                    type="text"
                                    class="form-control bg-grey"
                                    id="inputToken"
                                    placeholder="Token"
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mt-3">
                                <div class="row">
                                  <!-- <div class="col-lg-4 col-sm-4">

                                  </div> -->
                                  <div class="col-lg-12 col-sm-12">
                                    <div class="row" style="margin: 0px !important;">
                                      <div class="form-group mb-0">
                                      <div class="col text-right" style="padding-left: 11px;">
                                        <button type="submit" class="btn btn-primary black-btn color-white" style="padding: 6px 35px;float: right;margin-right: 0px;">Activate Account</button>

                                      </div>
                                    </div>
                                    <div class="form-group mb-0">
                                      <div class="col text-left m-t-10px">
                                        <a class="" @click="GotoSignin()" style="font-size: 14px;">Login</a>
                                      </div>
                                    </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                          <!-- <div class="col-lg-12">
                            <div class="row">

                            </div>
                          </div> -->

                        </div>
                      </div>
                    </form>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <training-footer></training-footer>
  </div>
</template>

<script>
import { extend } from 'vee-validate';
import { required} from 'vee-validate/dist/rules';
import ApiServices from '../service/ApiServices';
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';

extend('required', {
  ...required,
  message: 'This field is required'
});
export default {
  name: "activation",
  props: {},
  components: {
        trainingHeader,
        trainingFooter
    },
  data() {
    return {
      email:'',
      token: '',
      settings: settings
    };
  },
  methods: {
    onSubmit() {
      this.$root.loading = true;
      //let headers = {Authorization: 'Basic YWRtaW46ZGlzdHJpY3Q='};
      ApiServices.RestGetCall('api/avenir/subscribe/authorize',{"email":this.email,"token":this.token}, 'systemBasicAuth')
        .then(response =>{
          this.$root.loading = false;
          console.log(response);
          if(response.status.toLocaleLowerCase() == "success"){
            this.email=this.token='';
            this.$swal({
              text: response.message
            }).then(()=>{
              this.$router.push("/");
            });

          }else{
            this.$swal({
              text: response.message
            });
          }
        })
    },
    GotoSignin(){
      this.$router.push("/HomeIndia");
    }
  }
};
</script>
<style lang="scss" scoped>
.mdgridviewpage-bg {
  background-color:#fdfdfd;
  // background: url("../assets/img/sign_bg.jpg") no-repeat;
  // background-size: cover;
  // background-position: center;
  min-height: 100vh;
    // padding: 20px 40px;
    // display: flex;
    // flex-direction: column;

    // justify-content: center;
    // align-items: center;
   background-image: linear-gradient(0deg,rgba(0,0,0,.1),rgba(0,0,0,.1)),url(../assets/img/loginbg.jpg);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
}

body.green-theme .mdgridviewpage-bg {
  background-color: #006600;
  background: url("../assets/img/green-bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  padding: 20px 40px;
}
.mainform-holder {
  /*background: #fff;
  -webkit-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  -moz-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  border-radius: 10px;*/
  padding: 15px 5px;
}
.c-body {
  background-color: rgba(255, 255, 255, 0.78) ;
  padding-top: 10px !important;
  padding-bottom: 30px !important;
  // border-bottom-left-radius: 10px;
  // border-bottom-right-radius: 10px;
  /* border-top-left-radius: 10px;
  border-top-right-radius: 10px; */
  /* box-shadow: 0px 0px 3px rgba(53,53,53,0.26); */
  padding: 8px 5px;
  border-radius: 5px;
}


.card{
  background-color:transparent;
  box-shadow: 0px 0px 0px 0px 4px rgb(186, 186, 186) !important;
        border-radius: 10px;
        border: 0px !important;
        width: 450px;
}
.card-header{
        border-bottom: 0px;
        border-radius: 10px 10px 0 0 !important;
        padding:8px 12px !important;
    }
.form-control{
  background: #efeeee !important;
    border-color: #f2f2f2;
    color: #171a22 !important;
    font-size: 14px !important;
    font-weight: 200;
    border: 1px solid #e9e9e9;
}
a{
  cursor: pointer;
  color: rgb(121, 121, 121);

}
a:hover{
  text-decoration:underline !important;
}
input:-internal-autofill-selected {
  background: #ddd !important;
    border-color: #f2f2f2 !important;
}
*{
  color: #4c4c4c;
}
label{
  font-weight: 200;
}
.globalconfigcontainer{
    display: flex;
    justify-content: center;
    align-items: center;
    // height:80vh;
  }
  .navbar{
  background: #edd0f5!important;
}
.logoImage{
  display: flex;
  justify-content: center;
  position: absolute;
}
.logoImageDiv{
     position: relative;
    z-index: 9;
    top: -100px;
    padding: 10px 10px;
    left: 0;
    width: 175px;
    height: 90px;
    background-color: rgba(255, 255, 255, 0.78);
    border-top-left-radius: 110px;
    border-top-right-radius: 110px;
    /* border: 10px solid gray; */
    border-bottom: 0;
}
.logoImageDiv img{
        position: absolute;
    top: 26px;
    left: 36px;
}.headerTitle{
  font-size: 2rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.minText p{
  margin-bottom: 0;
  padding-top: 5%;
  font-size: 16px;
  margin-left: 0;
  color: #000;
}
.minText p span{
  display: block;
  color: #000;
}
// #footer .c_div .c_logo{
//   width: 15%;
// }
footer{
  background-color: #f6f0f8;
}
</style>
